import { getDexfProducts } from '../../api/dexf';
/**
 * Map the item list from the vpc to matching global products.
 * @param vpcItemList The item list from the VPC
 * @param dexfProducts Products in the item list, fetched from DEXF.
 * @returns An item list with global article ID:s
 */
export const localToGlobalItemList = (vpcItemList, dexfProducts) => {
    const globalItemList = vpcItemList.map(vpcItem => {
        const dexfProduct = dexfProducts.find(dexfProd => dexfProd.content?.itemNoLocal === vpcItem.id);
        if (dexfProduct) {
            // itemNoGlobal should exist here, but fallback to existing ID (might be local) if not
            return { ...vpcItem, id: dexfProduct.content?.itemNoGlobal ?? vpcItem.id };
        }
        return vpcItem;
    });
    return globalItemList;
};
/**
 * If the products in a vpc item list is missing, we assume that they are local products
 * and convert them to global instead. Every local product should have a global "parent".
 * @param icfArticle The solution we have fetched.
 * @param products List of fetched products for the selected locale.
 * @returns An item list with only global items.
 */
export const mapToGlobalIfMissing = async (icfArticle, products) => {
    let articles = icfArticle.vpcData.itemList;
    // If the products are missing, it most certainly means the design contains local products instead
    const isMissingProducts = !articles?.some(listItem => products.find(product => listItem.id === product.id));
    if (isMissingProducts) {
        // Fetch products from DEXF, works for both local and global
        const dexfProducts = await getDexfProducts(icfArticle.vpcData.itemList ?? []);
        // Convert the item list to the corresponding global products instead
        articles = localToGlobalItemList(icfArticle.vpcData.itemList ?? [], dexfProducts);
    }
    return articles;
};
//# sourceMappingURL=util.js.map